import { EventBus } from '../../helpers';

type PromoCodesEvents = {
  promoCodeApplySuccess: [code: string];
  promoCodeApplyError: [code: string, messages: string[]];
  promoCodeRemove: [code: string];
};

class PromoCodesEventBus extends EventBus<PromoCodesEvents> {}

export const promoCodesEventBus = new PromoCodesEventBus();
